import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"h-100 overflow-y-hidden",attrs:{"id":"app"}},[_c('router-view',{staticClass:"make"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }